import styled from 'styled-components';
import { ApRadio } from '@alixpartners/ui-components';
import { brandColors } from 'styles/colors';
import { Dropdown as UnstyledDropdown } from '../../Details/styles';
import { Overlay, Content } from 'components/Dropdown/styles';
import { black, grey200 } from 'styles/colors';

export const SmallButtonLink = styled.span`
	font-size: 13px;
	color: ${brandColors.green};
	cursor: pointer;
	margin-right: 16px;
	margin-top: 6px;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 19px;
	text-transform: uppercase;
`;

export const Dropdown = styled(UnstyledDropdown)`
	${Overlay} {
		max-width: 360px !important;
		min-width: 360px !important;
	}

	${Content} {
		display: flex;
		width: 100%;
		flex-direction: column;
	}
`;

export const ToggleWrapper = styled.div`
	padding: 24px 32px 0 32px;
	display: flex;
	flex-direction: column;
`;

export const Divider = styled.div`
	margin: 0 32px;
	border-bottom: 1px solid ${grey200};
	margin-bottom: 8px;
`;

export const DividerFilter = styled.div`
	border-bottom: 1px solid ${grey200};
	margin-bottom: 16px;
`;

export const ToggleRow = styled.div`
	display: flex;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	color: ${black};
	text-transform: uppercase;
	line-height: 20px;
	margin-top: 10px;
	margin-bottom: 26px;
	justify-content: space-between;
`;

export const Radio = styled(ApRadio)`
	margin-right: 6px;
`;

export const RadioWrapper = styled.div`
	margin-top: -6px;
	margin-bottom: 22px;

	label {
		font-size: 16px !important;
		margin-left: 6px;
		margin-top: 20px;
	}
`;
